// Angular
import { Observable, catchError, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';

// Libraries

import { Store } from '@ngxs/store';

// Services
import { CoreService } from '../services';

// Store
import { AuthActions } from '../../modules/auth/state/auth.action';
import { UserAuthActions } from '../../modules/auth/state/user-auth.action';

// Enums
import { StatusType } from '../enums';
import { AppCleanup } from '../models';

const XSSI_PREFIX = /^\)\]\}',?\n/;

@Injectable()
export class ErrorInterceptor extends AppCleanup implements HttpInterceptor {
	constructor(
		private router: Router,
		private coreService: CoreService,
		private store: Store
	) {
		super();
	}

	// intercept request and add token
	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		// Check if this request should skip the interceptor
		if (request.headers.has('Skip-Error-Interceptor')) {
			// Clone the request without the custom header (optional)
			const newHeaders = request.headers.delete('Skip-Error-Interceptor');
			const clonedRequest = request.clone({ headers: newHeaders });
			return next.handle(clonedRequest); // just pass it through untouched
		}

		return next.handle(request).pipe(
			catchError((error) => {
				let errorMessage = 'Unknown error type.';

				if (error instanceof HttpErrorResponse) {
					errorMessage = error.message;

					// Endpoints can return an ApiException object as a json string
					if (typeof error.error === 'string') {
						try {
							const apiExceptionObject = JSON.parse(error.error);
							if (typeof apiExceptionObject?.message === 'string') {
								errorMessage = apiExceptionObject.message;
							}
						} catch {}
					}
				} else if (error instanceof Error) {
					errorMessage = error.message;
				}

				this.coreService.toast({ message: errorMessage, type: StatusType.DANGER });

				if (error instanceof HttpErrorResponse) {
					if (!this.isViewer && error.status === 401) {
						this.store.dispatch(new AuthActions.DeleteToken());
						this.store.dispatch(new UserAuthActions.DeleteUser());
						this.router.navigate(['/auth/login']);
					}
				}

				return throwError(error);
			})
		);
	}

	// event => {
	// 	 if (event instanceof HttpResponse) {
	// 		// http response status code - Nothing needed for now
	// 	}
	// },
	// (httpErrorResponse: HttpErrorResponse) => {
	// 	// http response status code
	// 	// tslint:disable-next-line:no-debugger
	// 	console.error(httpErrorResponse.status);
	// 	console.error(httpErrorResponse.message);
	// 	console.error(httpErrorResponse.error);

	// 	if(!this.isViewer && httpErrorResponse.status == 401) {
	// 		localStorage.removeItem(environment.authTokenKey);
	// 		this.router.navigate(['/auth/login']);
	// 	}

	private processJsonResponse(body: string): any {
		return body.replace(XSSI_PREFIX, '');
	}
}
